module.exports = __webpack_public_path__ + "static/media/furvac360-4.49449cdd.jpg";